import { Typography } from '@mui/material';
import React from 'react';
import { CheckMarkIcon, CloseIcon } from '../../components/icons/icons';

const PasswordGuide = ({ passwordConditions }) => {
    const styledConditions = {
        display: 'flex',

        alighnItems: 'center',
        mb: '1px',
    };
    const checkIconStyles = {
        width: '1rem',
        mr: 1,
        pt:'.1rem'
       
    };
    return passwordConditions?.map((passData, index) => (
        <Typography component='div' sx={styledConditions} key={index}>
            {passData.state ? (
                <CheckMarkIcon sx={checkIconStyles} />
            ) : (
                <CloseIcon sx={checkIconStyles} />
            )}
            {index + 1}.{passData?.condition}
        </Typography>
    ));
};
export default PasswordGuide;
